<template>
  <v-dialog v-model="value" persistent lazy full-width>
    <v-card v-if="value && showmap">
      <v-card-text>
        <strong>แก้ไขที่อยู่จัดส่ง</strong>
        <gmap-address
          class="mt-2"
          :placesInfoLabel.sync="placesInfoLabel"
          v-validate="{ required: true }"
          name="ปักหมุดที่อยู่"
          v-model="gmapvalue"
          v-on:input="gmapLocation"
          :lastordercoords="gmapvalue"
          :error="errors.has('ปักหมุดที่อยู่')"
          :shoplocation="shoplocation"
          :nvbb="true"
        ></gmap-address>
        <div class="px-2 py-4 my-2 primary white--text">
          <v-layout :value="true" prominent text color="primary">
            <v-flex class="text-xs-center pa-2">
              <em style="font-size: 35px" class="fas fa-map-pin" />
            </v-flex>

            <v-flex class="pa-2">
              <div v-if="placesInfoLabel">
                <strong>{{ `${placesInfoLabel}` }}</strong>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onCancel" color="grey" outline>
          {{ $t('cancel') }}
        </v-btn>
        <v-btn @click="onSelect" color="primary" depressed>
          {{ $t('Select') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GmapAddress from '@/components/elements/GmapAddress.vue'
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: ['value', 'location'],
  components: {
    GmapAddress
  },
  data() {
    return {
      shippingAddressSet: null,
      placesInfoLabel: null,
      gmapvalue: null,
      shoplocation: [],
      showmap: false,
      googleapikey: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    }),
    distances() {
      return this.$store.state.distances
    },
    gmapapikey() {
      return 'AIzaSyA4vEtOImJL00yQs_tFrEhKKWFoRO959xc'
    }
  },
  mounted() {
    this.gmapvalue = cloneDeep(this.location)
    if (this.gmapapikey) this.insertGoogleMapScript()
  },
  methods: {
    onCancel() {
      this.gmapvalue = cloneDeep(this.location)
      this.$emit('input', false)
    },
    onSelect() {
      this.$emit('changeLocation', {
        location: this.gmapvalue,
        placesinfolabel: this.placesInfoLabel
      })
      this.$emit('input', false)
    },
    insertGoogleMapScript() {
      var vm = this
      vm.showmap = false
      let externalScript = document.createElement('script')
      externalScript.setAttribute(
        'src',
        `https://maps.googleapis.com/maps/api/js?key=${vm.gmapapikey}&language=th&libraries=places`
      )
      externalScript.async = true
      externalScript.defer = true
      externalScript.onload = () => {
        vm.showmap = true
      }
      document.head.appendChild(externalScript)
    },
    gmapLocation() {
      var vm = this
      var stringlatlng = this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      var service = new google.maps.DistanceMatrixService()
      var origins = [stringlatlng]
      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH'
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          vm.shippingAddressSet = response.destinationAddresses[0]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SelectGmap.vue